<template>
    <router-link 
        class="gz-sideMenu__item"
        :to="to"
        tag="div">
        <div
            class="gz-sideMenu__item__icon" 
            :class="[count && !this.$store.getters['authLayoutSideMenuShow'] ? 'gz-sideMenu__item__icon_withNote' : false]"
            :title="title">
            <span :class="icon"></span>
        </div>
        
        <div
            key="sideMenuItemContent" 
            class="gz-sideMenu__item__content"
            :class="[this.$store.getters['authLayoutSideMenuShow'] ? 'opacity' : 'opacity-0']">
            <span class="gz-sideMenu__item__name">{{ title }}</span>
            <div
                v-if="note" 
                class="gz-sideMenu__item__note__container">
                <span class="icon-notification gz-sideMenu__item__note__icon"></span>
                <span class="gz-sideMenu__item__note">{{ note }}</span>
            </div>
        </div>
        <div
            v-if="count"
            key="sideMenuItemCount" 
            class="gz-sideMenu__item__counter"
            :class="[this.$store.getters['authLayoutSideMenuShow'] ? 'opacity' : 'opacity-0']">{{ count }}</div>
    </router-link>
</template>

<script>
export default {
    name: 'SideMenuItem',

    props: {
        icon: {
            type: String
        },
        title: {
            type: String,
            required: true
        },
        note: {
            type: String,
            default: ''
        },
        count: {
            type: String
        },
        to: {
            type: String,
            required: true  
        }
    }
}
</script>